import { TextField } from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Button, Tooltip } from "antd";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";

import { Switch } from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  AiOutlineCheck,
  AiOutlineClose,
  AiOutlineSearch,
} from "react-icons/ai";
import { BsHeartPulse, BsPencilSquare } from "react-icons/bs";
import { IoMdPower } from "react-icons/io";
import {
  MdDelete,
  MdEditDocument,
  MdLocationOn,
  MdOutlineCameraAlt,
  MdOutlineRefresh,
} from "react-icons/md";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { v4 as uuid } from "uuid";
import { apiClient } from "../../components/apiClient";
import CustomButton from "../../components/Button";
import CustomDataTable from "../../components/DataTable";
import DisplaySettings from "../../components/DisplayPreview/DisplaySettings/DisplaySettings";
import "./Displays.css";

const useDisplayId = () => {
  const { id } = useParams();
  return id;
};

const DisplayPreview = ({ accessToken, userId, sellerId, currentBusiness }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isEditingName, setIsEditingName] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [layoutArr, setLayoutArr] = useState([]);
  const [showPlusModal, setPlusModal] = useState(false);
  const [layoutsId, setLayoutId] = useState("");
  const [libraryIds, setLibraryIds] = useState([]);
  const [deactiveShowModal, setDeactiveShowModal] = useState(false);
  const [assignmentContainers, setAssignmentContainers] = useState([]);
  const [autoRefreshSettings, setAutoRefreshSettings] = useState({});
  const [assignedlayout, setAssignedlayout] = useState([]);
  const [displayLogs, setDisplayLogs] = useState([]);
  const [loadingLogs, setLoadingLogs] = useState(true);
  const [locationData, setLocationData] = useState([]);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [screenshotImage, setScreenshotImage] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [isScreenshotLoading, setIsScreenshotLoading] = useState(false);
  const [error, setError] = useState("");
  const [buttonColor, setButtonColor] = useState("");
  const [layoutValidationWarnings, setLayoutValidationWarnings] = useState([]);
  const [isValidationPassed, setIsValidationPassed] = useState(true);
  const [isMainLayoutShrinked, setIsMainLayoutShrinked] = useState(false);
  const [showSummaryModal, setShowSummaryModal] = useState(false);

  const days = ["S", "M", "T", "W", "T", "F", "S"];
  const multiple = false;

  const modalBodyRef = useRef(null);

  const scrollModalToTopSmooth = useCallback(() => {
    requestAnimationFrame(() => {
      if (
        modalBodyRef.current &&
        typeof modalBodyRef.current.scrollTo === "function"
      ) {
        modalBodyRef.current.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        try {
          window.scrollTo({ top: 0, behavior: "smooth" });
        } catch (_err) {}
      }
    });
  }, []);

  const handleModalScroll = useCallback(() => {
    if (modalBodyRef.current) {
      const scrollTop = modalBodyRef.current.scrollTop;
      const hasMainLayout =
        assignedlayout.some((layout) => layout.isAlldayEnabled) ||
        assignmentContainers.some((container) => container.isAlldayEnabled);

      if (hasMainLayout && scrollTop > 50 && !isMainLayoutShrinked) {
        setIsMainLayoutShrinked(true);
      }
    }
  }, [assignedlayout, assignmentContainers, isMainLayoutShrinked]);

  useEffect(() => {
    if (showModal && modalBodyRef.current) {
      const modalElement = modalBodyRef.current;
      modalElement.addEventListener("scroll", handleModalScroll);

      return () => {
        modalElement.removeEventListener("scroll", handleModalScroll);
      };
    }
  }, [showModal, handleModalScroll]);

  const reorderMainLayoutFirst = useCallback((layouts) => {
    if (!Array.isArray(layouts)) return layouts;
    const result = [...layouts];
    const mainIndex = result.findIndex((layout) => layout.isAlldayEnabled);
    if (mainIndex > 0) {
      const [mainLayout] = result.splice(mainIndex, 1);
      result.unshift(mainLayout);
    }
    return result;
  }, []);

  const moveItem = useCallback((array, fromIndex, toIndex) => {
    if (!Array.isArray(array)) return array;
    const result = [...array];
    if (
      fromIndex < 0 ||
      toIndex < 0 ||
      fromIndex >= result.length ||
      toIndex >= result.length
    ) {
      return result;
    }
    const [item] = result.splice(fromIndex, 1);
    result.splice(toIndex, 0, item);
    return result;
  }, []);

  const imageUrl = require("../../assets/defaultDisplay.png");
  const handleDeleteLayout = async (layoutsId, displayId, index) => {
    try {
      await apiClient(accessToken).post(`display/deactivate/layout`, {
        layoutId: layoutsId,
        displayId: displayId,
        index: index,
      });
      const updatedLayouts = assignedlayout.filter(
        (_layout, idx) => idx !== index
      );

      setAssignedlayout(updatedLayouts);
      toast.success("Layout delete successfully");
    } catch (error) {
      console.error(error.message);
      toast.error("Error deleting Layout:", error.message);
    }
  };
  const [data, setData] = useState({});
  const displayId = useDisplayId();

  const fetchDisplayDetailsById = useCallback(async () => {
    try {
      const response = await apiClient(accessToken).get(
        `display/details/${displayId}`
      );
      const currentBusiness = await apiClient(accessToken).get(
        `display/${displayId}/preview/currentBusiness`
      );
      localStorage.setItem(
        "currentbusinesssid",
        currentBusiness.data.businessId
      );
      setData(response.data.data);
      setNewDisplayName(response.data.data.displayName);
      setScreenshotImage(response.data.data.screenShotPath);
    } catch (error) {
      console.error("Error fetching display details:", error);
    }
  }, [accessToken, displayId]);

  useEffect(() => {
    if (displayId) {
      fetchDisplayDetailsById();
    }
  }, [displayId, accessToken, fetchDisplayDetailsById]);

  // Update libraryIds whenever assignedlayout changes to reflect layout selections immediately
  useEffect(() => {
    if (assignedlayout && assignedlayout.length > 0) {
      const updatedLibraryIds = assignedlayout.map((assignment) => {
        if (assignment.layoutId) {
          const selectedLayout = layoutArr.find(
            (layout) => layout.id === assignment.layoutId
          );
          if (selectedLayout?.libraryIds) {
            try {
              return JSON.parse(selectedLayout.libraryIds);
            } catch (error) {
              console.error("Error parsing libraryIds:", error);
              return [];
            }
          }
        }
        return [];
      });
      setLibraryIds(updatedLibraryIds);
    }
  }, [assignedlayout, layoutArr]);

  const { id, screenShotPath, location, fcmToken, displayName } = data;

  const handleClose = () => {
    setShowModal(false);
    setShowSummaryModal(false);
    setIsMainLayoutShrinked(false);
  };
  const handleShow = () => setShowModal(true);

  const handleNextToSummary = () => {
    setShowModal(false);
    setShowSummaryModal(true);
  };

  const handleBackToLayout = () => {
    setShowSummaryModal(false);
    setShowModal(true);
  };
  const [newDisplayName, setNewDisplayName] = useState(displayName || "");

  const fetchData = useCallback(async () => {
    try {
      const data = await apiClient(accessToken).get(
        `/display/getActiveLayout/${sellerId}`
      );

      setLayoutArr(data.data.data);

      const addedlayouts = await apiClient(accessToken).get(
        `display/getdisplay/layouts/${displayId}`
      );

      if (!addedlayouts.data.data?.data?.displayLayouts) {
        console.warn("No display layouts found in response");
        setAssignedlayout([]);
        setLibraryIds([]);
        return;
      }

      const layoutsWithDays = addedlayouts.data.data.data.displayLayouts.map(
        (layout) => {
          const dayNameToIndex = {
            sunday: 0,
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6,
          };
          const selectedDays = layout.assignedDays.map(
            (day) => dayNameToIndex[day.toLowerCase()]
          );

          const startTime = Array.isArray(layout.startTime)
            ? layout.startTime[0]
            : layout.startTime;
          const endTime = Array.isArray(layout.endTime)
            ? layout.endTime[0]
            : layout.endTime;
          const isAlldayEnabled =
            startTime === "00:00" &&
            endTime === "23:59" &&
            selectedDays.length === 7 &&
            !layout.startDate &&
            !layout.endDate;

          return {
            ...layout,
            selectedDays,
            originalStartDate: layout.startDate,
            originalEndDate: layout.endDate,
            isDateRangeEnabled: layout.startDate && layout.endDate,
            startDate: layout.startDate ? moment(layout.startDate) : null,
            endDate: layout.endDate ? moment(layout.endDate) : null,
            isAlldayEnabled: isAlldayEnabled,
          };
        }
      );

      const mainIdx = layoutsWithDays.findIndex((l) => l.isAlldayEnabled);
      if (mainIdx > 0) {
        const reorderedLayouts = reorderMainLayoutFirst(layoutsWithDays);
        setAssignedlayout(reorderedLayouts);
        const reorderedLibraryIds = moveItem(
          addedlayouts.data.data.data.displayLayouts.map((eachlayout) =>
            JSON.parse(eachlayout.libraryIds)
          ),
          mainIdx,
          0
        );
        setLibraryIds(reorderedLibraryIds);
      } else {
        setAssignedlayout(layoutsWithDays);
        const mappedLibraryIds = addedlayouts.data.data.data.displayLayouts.map(
          (eachlayout) => JSON.parse(eachlayout.libraryIds)
        );
        setLibraryIds(mappedLibraryIds);
      }
      localStorage.setItem(
        "addedlayouts",
        JSON.stringify(addedlayouts.data.data.data.displayLayouts)
      );
    } catch (error) {
      console.error("Error fetching layout data:", error);
      console.error("Error details:", error.response?.data);
      // Set empty states on error to prevent UI issues
      setAssignedlayout([]);
      setLayoutArr([]);
      setLibraryIds([]);
    }
  }, [accessToken, displayId, sellerId, moveItem, reorderMainLayoutFirst]);

  useEffect(() => {
    fetchData();
  }, [accessToken, fetchData]);

  const handleDayClickForAssigned = (layoutIndex, dayIndex) => {
    setAssignedlayout((prevLayouts) => {
      const newLayouts = [...prevLayouts];
      const currentDays = newLayouts[layoutIndex].selectedDays;
      if (currentDays.includes(dayIndex)) {
        newLayouts[layoutIndex].selectedDays = currentDays.filter(
          (d) => d !== dayIndex
        );
      } else {
        newLayouts[layoutIndex].selectedDays = [...currentDays, dayIndex];
      }
      return newLayouts;
    });
  };

  const handlePlusClose = () => setPlusModal(false);
  const [deletionIndex, setDeletionIndex] = useState(null);
  const handlePlusModalShow = (layId, idx) => {
    setLayoutId(layId);
    setDeletionIndex(idx);
    setPlusModal(true);
  };

  const handleDeactiveModal = () => {
    setDeactiveShowModal(true);
  };

  const addAssignmentContainer = () => {
    setAssignmentContainers((prevContainers) => [
      ...prevContainers,
      {
        id: uuid(),
        layoutId: "",
        name: "",
        selectedStartTime: "09:00",
        selectedEndTime: "17:00",
        step: "3600",
        autoRefresh: false,
        selectedDays: [0, 1, 2, 3, 4, 5, 6],
        isAlldayEnabled: false,
        isDateRangeEnabled: false,
      },
    ]);
    setAutoRefreshSettings((prevSettings) => ({
      ...prevSettings,
      [uuid()]: false,
    }));
  };

  const clickToDeactive = async () => {
    try {
      const postData = {
        displayId: displayId,
        userId: userId,
      };
      await apiClient(accessToken).post(`display/deactive`, postData);
    } catch (error) {
      console.error("Error", error);
    }
  };

  const clickToSendNotification = async (title) => {
    try {
      if (title.toLowerCase() === "screenshot") {
        setIsScreenshotLoading(true);
      }
      const tokenResponse = await apiClient(accessToken).get(
        "/display/accessToken"
      );
      if (tokenResponse.status !== 200) {
        throw new Error("Failed to fetch access token");
      }

      const fcmAccessToken = tokenResponse.data.token;
      const notificationData = {
        message: {
          token: fcmToken,
          notification: {
            title: title,
            body: JSON.stringify({
              refreshToken: "",
            }),
          },
        },
      };

      const projectId = process.env.REACT_APP_PROJECT_ID;
      const notificationResponse = await fetch(
        `https://fcm.googleapis.com/v1/projects/${projectId}/messages:send`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${fcmAccessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(notificationData),
        }
      );

      if (!notificationResponse.ok) {
        throw new Error("Failed to send notification");
      }

      await notificationResponse.json();

      if (title.toLowerCase() === "restart") {
        toast.success("Restart command sent successfully");
      } else if (title.toLowerCase() === "refresh") {
        toast.success("Refresh command sent successfully");
      }

      await fetchScreenshotImage();
      await fetchDisplayLogs();

      if (title.toLowerCase() === "screenshot") {
        setIsScreenshotLoading(false);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error in clickToSendNotification:", error);
      if (title.toLowerCase() === "screenshot") {
        setIsScreenshotLoading(false);
      }
      toast.error(
        `Error sending ${title.toLowerCase()} command: ${error.message}`
      );
    }
  };

  const handleEditNameStart = () => {
    setIsEditingName(true);
  };

  const handleNameCancel = () => {
    setNewDisplayName(displayName);
    setIsEditingName(false);
  };

  const handleUpdateName = async () => {
    try {
      const response = await apiClient(accessToken).put(
        `/display/update-item`,
        {
          id: id,
          updates: {
            displayName: newDisplayName,
          },
        }
      );

      if (response.status === 200) {
        setIsEditingName(false);
        toast.success("Display name updated successfully");
      } else {
        throw new Error(`Update failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error updating display name:", error);
      toast.error("Error updating display name: " + error.message);
    }
  };

  const [showrefreshmodal, setShowrefreshmodal] = useState(false);
  const handlerefreshmodal = () => {
    setShowrefreshmodal(true);
  };

  const doTimeRangesOverlap = (start1, end1, start2, end2) => {
    const parseTime = (timeStr) => {
      const [hours, minutes] = timeStr.split(":").map(Number);
      return hours * 60 + minutes;
    };

    const start1Minutes = parseTime(start1);
    const end1Minutes = parseTime(end1);
    const start2Minutes = parseTime(start2);
    const end2Minutes = parseTime(end2);

    const isOvernight1 = end1Minutes <= start1Minutes;
    const isOvernight2 = end2Minutes <= start2Minutes;

    if (isOvernight1 && isOvernight2) {
      return true;
    } else if (isOvernight1) {
      return (
        start1Minutes <= start2Minutes ||
        end1Minutes >= end2Minutes ||
        start2Minutes <= end1Minutes ||
        end2Minutes >= start1Minutes
      );
    } else if (isOvernight2) {
      return (
        start2Minutes <= start1Minutes ||
        end2Minutes >= end1Minutes ||
        start1Minutes <= end2Minutes ||
        end1Minutes >= start2Minutes
      );
    } else {
      return start1Minutes < end2Minutes && start2Minutes < end1Minutes;
    }
  };

  const doScheduleDaysOverlap = (days1, days2) => {
    return days1.some((day) => days2.includes(day));
  };

  const doDateRangesOverlap = (start1, end1, start2, end2) => {
    if (!start1 || !end1 || !start2 || !end2) {
      return true;
    }

    const startDate1 = moment(start1);
    const endDate1 = moment(end1);
    const startDate2 = moment(start2);
    const endDate2 = moment(end2);

    return (
      startDate1.isSameOrBefore(endDate2) && startDate2.isSameOrBefore(endDate1)
    );
  };

  const generateLayoutSummary = useCallback(() => {
    const allLayouts = [
      ...assignedlayout.map((layout) => ({
        name: layout.name || "Layout",
        type: "existing",
        startTime: Array.isArray(layout.startTime)
          ? layout.startTime[0]
          : layout.startTime,
        endTime: Array.isArray(layout.endTime)
          ? layout.endTime[0]
          : layout.endTime,
        selectedDays: layout.selectedDays || [],
        startDate: layout.startDate,
        endDate: layout.endDate,
        isDateRangeEnabled: layout.isDateRangeEnabled,
        isAlldayEnabled: layout.isAlldayEnabled,
        id: layout.layoutId,
      })),
      ...assignmentContainers
        .filter((container) => !!container.layoutId)
        .map((container) => {
          const selectedLayout = layoutArr.find(
            (layout) => layout.id === container.layoutId
          );
          return {
            name: selectedLayout?.name || container.name || "New Layout",
            type: "new",
            startTime: container.selectedStartTime,
            endTime: container.selectedEndTime,
            selectedDays: container.selectedDays || [],
            startDate: container.startDate,
            endDate: container.endDate,
            isDateRangeEnabled: container.isDateRangeEnabled,
            isAlldayEnabled: container.isAlldayEnabled,
            id: container.layoutId,
          };
        }),
    ];

    const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    return allLayouts.map((layout) => {
      const selectedDayNames = layout.selectedDays
        .map((dayIndex) => dayNames[dayIndex])
        .join(", ");

      // Generate detailed description
      let detailedDescription = "";

      if (layout.isAlldayEnabled) {
        detailedDescription =
          "This layout runs continuously 24/7 as the global base layout. It serves as the default content when no other scheduled layouts are active.";
      } else {
        const timeDesc = `from ${layout.startTime} to ${layout.endTime}`;
        const dayDesc = selectedDayNames || "no days selected";

        if (layout.isDateRangeEnabled && layout.startDate && layout.endDate) {
          const startDate = moment(layout.startDate).format("MMM DD, YYYY");
          const endDate = moment(layout.endDate).format("MMM DD, YYYY");
          detailedDescription = `This layout will play ${timeDesc} on ${dayDesc}, but only between ${startDate} and ${endDate}. Outside this date range, the layout will not be active.`;
        } else {
          detailedDescription = `This layout will play ${timeDesc} on ${dayDesc} every week. No date restrictions are set, so it will continue indefinitely.`;
        }
      }

      return {
        ...layout,
        dayNames: selectedDayNames,
        timeRange: layout.isAlldayEnabled
          ? "24 Hours (Global Base)"
          : `${layout.startTime} - ${layout.endTime}`,
        dateRange:
          layout.isDateRangeEnabled && layout.startDate && layout.endDate
            ? `${moment(layout.startDate).format("DD/MM/YYYY")} - ${moment(
                layout.endDate
              ).format("DD/MM/YYYY")}`
            : "No date restriction",
        detailedDescription,
      };
    });
  }, [assignedlayout, assignmentContainers, layoutArr]);

  const validateMainLayoutRequirements = useCallback(() => {
    const warnings = [];
    const seenConflictKeys = new Set();
    let isValid = true;

    const allLayouts = [
      ...assignedlayout.map((layout) => ({
        isMainLayout: layout.isAlldayEnabled,
        name: layout.name || "Layout",
        type: "existing",
        startTime: Array.isArray(layout.startTime)
          ? layout.startTime[0]
          : layout.startTime,
        endTime: Array.isArray(layout.endTime)
          ? layout.endTime[0]
          : layout.endTime,
        selectedDays: layout.selectedDays || [],
        startDate: layout.startDate,
        endDate: layout.endDate,
        isDateRangeEnabled: layout.isDateRangeEnabled,
        id: layout.layoutId,
      })),
      ...assignmentContainers
        .filter((container) => !!container.layoutId)
        .map((container) => ({
          isMainLayout: container.isAlldayEnabled,
          name: container.name || "New Layout",
          type: "new",
          startTime: container.selectedStartTime,
          endTime: container.selectedEndTime,
          selectedDays: container.selectedDays || [],
          startDate: container.startDate,
          endDate: container.endDate,
          isDateRangeEnabled: container.isDateRangeEnabled,
          id: container.layoutId,
        })),
    ];

    // Check if there are any layouts assigned at all
    const validAssignmentContainers = assignmentContainers.filter(
      (container) => !!container.layoutId
    );
    const emptyAssignmentContainers = assignmentContainers.filter(
      (container) => !container.layoutId
    );
    const totalLayoutsCount =
      assignedlayout.length + validAssignmentContainers.length;

    if (emptyAssignmentContainers.length > 0) {
      warnings.push({
        type: "error",
        message:
          "Please select a layout for all assignment containers or remove empty ones.",
      });
      isValid = false;
    } else if (totalLayoutsCount === 0) {
      warnings.push({
        type: "error",
        message: "Please assign at least one layout to continue.",
      });
      isValid = false;
    }

    const mainLayouts = allLayouts.filter((layout) => layout.isMainLayout);
    const mainLayoutCount = mainLayouts.length;

    if (totalLayoutsCount > 0 && mainLayoutCount === 0) {
      warnings.push({
        type: "error",
        message: "Set a Global base layout to continue.",
      });
      isValid = false;
    } else if (!multiple && mainLayoutCount > 1) {
      // Only warn about multiple main layouts, don't auto-fix during editing
      // Auto-fix will only happen during save operation
      warnings.push({
        type: "error",
        message: `Multiple Global base layouts detected. Only one layout can be global at a time. Please disable global mode for other layouts.`,
      });
      isValid = false;
    }

    const nonMainLayouts = allLayouts.filter((layout) => !layout.isMainLayout);

    // Check for layouts that have the same configuration as the main layout
    if (mainLayoutCount === 1) {
      const mainLayout = mainLayouts[0];
      const duplicateGlobalLayouts = nonMainLayouts.filter((layout) => {
        // Check if this layout has the same global configuration as the main layout
        const hasSameTime =
          layout.startTime === "00:00" && layout.endTime === "23:59";
        const hasAllDays =
          layout.selectedDays && layout.selectedDays.length === 7;
        const hasNoDateRange = !layout.startDate && !layout.endDate;

        return hasSameTime && hasAllDays && hasNoDateRange;
      });

      if (duplicateGlobalLayouts.length > 0) {
        const duplicateNames = duplicateGlobalLayouts
          .map((layout) => layout.name)
          .join(", ");
        warnings.push({
          type: "warning",
          message: `Layout(s) "${duplicateNames}" have the same configuration as the global layout "${mainLayout.name}". Consider enabling them as global or adjusting their settings.`,
        });
      }
    }

    for (let i = 0; i < nonMainLayouts.length; i++) {
      const layout1 = nonMainLayouts[i];

      for (let j = i + 1; j < nonMainLayouts.length; j++) {
        const layout2 = nonMainLayouts[j];

        if (
          !doScheduleDaysOverlap(layout1.selectedDays, layout2.selectedDays)
        ) {
          continue;
        }

        if (layout1.isDateRangeEnabled && layout2.isDateRangeEnabled) {
          if (
            !doDateRangesOverlap(
              layout1.startDate,
              layout1.endDate,
              layout2.startDate,
              layout2.endDate
            )
          ) {
            continue;
          }
        }

        if (
          doTimeRangesOverlap(
            layout1.startTime,
            layout1.endTime,
            layout2.startTime,
            layout2.endTime
          )
        ) {
          // Check if this is an exact time match (same start and end times)
          const isExactTimeMatch =
            layout1.startTime === layout2.startTime &&
            layout1.endTime === layout2.endTime;

          // Only show warning for exact time matches
          if (isExactTimeMatch) {
            const conflictDays = layout1.selectedDays.filter((day) =>
              layout2.selectedDays.includes(day)
            );
            const dayAbbr = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
            const conflictDayNames = conflictDays
              .map((dayIndex) => dayAbbr[dayIndex])
              .join(", ");

            const id1 = layout1.id || layout1.name;
            const id2 = layout2.id || layout2.name;
            const key =
              [id1, id2].sort().join("|") +
              `:${conflictDayNames}` +
              `:${layout1.startTime}-${layout1.endTime}:${layout2.startTime}-${layout2.endTime}`;
            if (!seenConflictKeys.has(key)) {
              seenConflictKeys.add(key);
              warnings.push({
                type: "error",
                message: `Conflict: "${layout1.name}" has exact same time as "${layout2.name}" on ${conflictDayNames}.`,
              });
              isValid = false;
            }
          }
        }
      }
    }

    setLayoutValidationWarnings(warnings);

    // Check if there are any warning messages that should disable the buttons
    const hasWarnings = warnings.some((warning) => warning.type === "warning");

    const finalValidationResult = isValid && !hasWarnings;
    setIsValidationPassed(finalValidationResult);

    return finalValidationResult;
  }, [assignedlayout, assignmentContainers, multiple]);

  const handleSaveDisplay = async () => {
    try {
      // Auto-fix multiple global layouts before validation
      const allLayouts = [
        ...assignedlayout.map((layout) => ({
          isMainLayout: layout.isAlldayEnabled,
          name: layout.name || "Layout",
          type: "existing",
          id: layout.layoutId,
        })),
        ...assignmentContainers
          .filter((container) => !!container.layoutId)
          .map((container) => ({
            isMainLayout: container.isAlldayEnabled,
            name: container.name || "New Layout",
            type: "new",
            id: container.layoutId,
          })),
      ];

      const mainLayouts = allLayouts.filter((layout) => layout.isMainLayout);
      const mainLayoutCount = mainLayouts.length;

      // Auto-fix multiple global layouts during save
      if (!multiple && mainLayoutCount > 1) {
        const firstMainLayout = mainLayouts[0];

        // Update existing layouts (assignedlayout)
        const updatedAssignedLayout = assignedlayout.map((layout) => ({
          ...layout,
          isAlldayEnabled:
            layout.layoutId === firstMainLayout.id ? true : false,
        }));

        // Update new containers (assignmentContainers)
        const updatedAssignmentContainers = assignmentContainers.map(
          (container) => ({
            ...container,
            isAlldayEnabled:
              container.layoutId === firstMainLayout.id ? true : false,
          })
        );

        // Update state to fix the issue automatically
        setAssignedlayout(updatedAssignedLayout);
        setAssignmentContainers(updatedAssignmentContainers);

        toast.info(
          `Multiple Global base layouts detected. Automatically kept "${firstMainLayout.name}" as the main layout and converted others to regular layouts.`
        );
      }

      const isMainLayoutValid = validateMainLayoutRequirements();

      const isEmptyContainer = (container) => {
        return (
          !container.layoutId &&
          container.selectedStartTime === "09:00" &&
          container.selectedEndTime === "17:00" &&
          (!container.selectedDays || container.selectedDays.length === 7)
        );
      };

      const activeAssignmentContainers = assignmentContainers.filter(
        (container) => !isEmptyContainer(container)
      );

      if (activeAssignmentContainers.length !== assignmentContainers.length) {
        setAssignmentContainers(activeAssignmentContainers);
      }

      const hasMissingLayoutOrTime = activeAssignmentContainers.some(
        (container) =>
          !container.layoutId ||
          !container.selectedStartTime ||
          !container.selectedEndTime
      );

      if (!isMainLayoutValid) {
        toast.error(
          "Please fix the main layout validation errors before saving."
        );
        return;
      }

      if (hasMissingLayoutOrTime) {
        const missingFields = [];
        activeAssignmentContainers.forEach((container, index) => {
          const missing = [];
          if (!container.layoutId) missing.push("layout");
          if (!container.selectedStartTime) missing.push("start time");
          if (!container.selectedEndTime) missing.push("end time");

          if (missing.length > 0) {
            missingFields.push(
              `Assignment ${index + 1}: missing ${missing.join(", ")}`
            );
          }
        });

        toast.error(
          `Please complete the following before saving:\n${missingFields.join(
            "\n"
          )}`
        );
        return;
      } else {
        const updatedAssignmentContainers = activeAssignmentContainers.map(
          (container) => {
            const selectedLayout = layoutArr.find(
              (layout) => layout.id === container.layoutId
            );
            return {
              ...container,
              name: selectedLayout?.name || container.name,
              autoRefresh: autoRefreshSettings[container.id] || false,
            };
          }
        );

        const dayNames = [
          "sunday",
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
        ];

        const postData = {
          DisplayLayout: [
            ...assignedlayout.map((layout) => {
              let startDate = null;
              let endDate = null;

              if (layout.isDateRangeEnabled) {
                if (layout.startDate) {
                  startDate = moment(layout.startDate).format("YYYY-MM-DD");
                }
                if (layout.endDate) {
                  endDate = moment(layout.endDate).format("YYYY-MM-DD");
                }
                if (!startDate && layout.originalStartDate) {
                  startDate = layout.originalStartDate;
                }
                if (!endDate && layout.originalEndDate) {
                  endDate = layout.originalEndDate;
                }
              }

              return {
                id: layout.layoutId,
                name: layout.name,
                startTime: Array.isArray(layout.startTime)
                  ? layout.startTime[0]
                  : layout.startTime,
                endTime: Array.isArray(layout.endTime)
                  ? layout.endTime[0]
                  : layout.endTime,
                assignedDays: layout.selectedDays.map(
                  (index) => dayNames[index]
                ),
                autoRefresh: false,
                startDate: startDate,
                endDate: endDate,
              };
            }),
            ...updatedAssignmentContainers.map((container) => ({
              id: container.layoutId,
              name: container.name,
              startTime: container.selectedStartTime,
              endTime: container.selectedEndTime,
              assignedDays: container.selectedDays.map(
                (index) => dayNames[index]
              ),
              autoRefresh: container.autoRefresh,
              startDate: container.startDate
                ? moment(container.startDate).format("YYYY-MM-DD")
                : null,
              endDate: container.endDate
                ? moment(container.endDate).format("YYYY-MM-DD")
                : null,
            })),
          ],
        };

        const response = await apiClient(accessToken).post(
          `display/assign/layout/${displayId}`,
          postData
        );

        if (response) {
          setShowrefreshmodal(true);
          await fetchData();
        }
        setShowModal(false);
        setShowSummaryModal(false);
        toast.success("Layout added successfully");
      }
    } catch (error) {
      console.error("Error saving display:", error.message);
      toast.error("Error saving display:", error.message);
    }
  };

  function formatTime(dateTimeString) {
    const date = new Date(dateTimeString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  const columns = [
    {
      name: "Log Event",
      selector: (param) => param.data,
      sortable: true,
    },

    {
      name: "Log Time",
      selector: (param) => formatTime(param.time),
      sortable: true,
      defaultSortField: true,
    },
  ];

  const fetchDisplayLogs = useCallback(async () => {
    try {
      const response = await apiClient(accessToken).get(
        `display/logs/${[[displayId]]}`
      );
      const sortedLogs = response.data.sort(
        (a, b) => new Date(b.time) - new Date(a.time)
      );
      setDisplayLogs(sortedLogs);
      setLoadingLogs(false);
    } catch (error) {
      console.error("Error fetching display logs:", error.message);
      setLoadingLogs(false);
    }
  }, [accessToken, displayId]);

  useEffect(() => {
    fetchDisplayLogs();
  }, [accessToken, fetchDisplayLogs]);

  const getLocationList = useCallback(async () => {
    try {
      const res = await apiClient(accessToken).get(
        `store/storelist/${sellerId}`
      );

      const updatedLocationData = res.data.data;

      const filteredLocationData = updatedLocationData.filter(
        (location) => location.id !== selectedLocation
      );

      setLocationData(filteredLocationData);
    } catch (err) {
      console.error(err);
    }
  }, [accessToken, sellerId, selectedLocation]);

  const [notificationStatus, setNotificationStatus] = useState(false);

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await apiClient(accessToken).get(
          `/display/list/${sellerId}`
        );
        const notificationStatusResponse =
          response?.data?.data[0].notificationPreference;
        setNotificationStatus(notificationStatusResponse);

        if (response?.data?.data?.length > 0) {
          const newData = response?.data?.data?.filter(
            (item, i) => item?.id === displayId
          );
          setSelectedLocation(
            newData?.length > 0 ? newData?.[0]?.location : ""
          );
        }
      } catch (error) {
        console.error("Error fetching display", error);
      }
    };

    fetchLocation();
  }, [accessToken, displayId, sellerId]);

  useEffect(() => {
    getLocationList();
  }, [showLocationModal, getLocationList]);

  const handleLocationChange = (locationId) => {
    setSelectedLocation(locationId);
  };

  const handleSaveLocation = async () => {
    await updateDisplay(selectedLocation);

    setShowLocationModal(false);
  };

  const updateDisplay = async (location) => {
    try {
      const idToken = accessToken;
      const client = apiClient(idToken);

      const response = await client.put(
        `display/update/${sellerId}/${displayId}`,
        {
          location,
        }
      );

      if (response.status === 200) {
        toast.success("Location updated successfully");
      } else {
        toast.error("Failed to update location");
      }
    } catch (error) {
      console.error("Error updating location", error);
      toast.error("Error updating location");
    }
  };

  const fetchScreenshotImage = useCallback(async () => {
    try {
      setIsImageLoading(true);
      setScreenshotImage(screenShotPath);
      setError(null);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsImageLoading(false);
    }
  }, [screenShotPath]);

  useEffect(() => {
    fetchScreenshotImage();
  }, [screenShotPath, fetchScreenshotImage]);

  const handleTakeScreenshot = () => {
    clickToSendNotification("screenshot");

    setTimeout(() => fetchScreenshotImage(), 30000);
    setTimeout(() => fetchScreenshotImage(), 60000);
  };

  const handleRefresh = async () => {
    try {
      await fetchData();
      await clickToSendNotification("Refresh");
    } catch (error) {
      console.error(error);
    } finally {
      window.location.reload();
    }
  };

  const performHealthCheck = useCallback(async () => {
    try {
      const response = await apiClient(accessToken).post(
        "/display/healthCheck",
        {
          businessId: currentBusiness.id,
          sellerId: sellerId,
          userId: userId,
          displayIds: [{ id: displayId, displayName: newDisplayName }],
        }
      );

      const healthData = response.data.healthCheckData[0];

      const lastCheckIn = new Date(healthData.lastCheckIn);
      const currentTime = new Date();
      const timeDifference = currentTime - lastCheckIn;
      const oneHourInMillis = 60 * 60 * 1000;

      setButtonColor(timeDifference <= oneHourInMillis ? "green" : "red");
    } catch (error) {
      console.error("Error performing health check:", error);
      setButtonColor("");
    }
  }, [
    accessToken,
    currentBusiness.id,
    displayId,
    newDisplayName,
    sellerId,
    userId,
  ]);

  useEffect(() => {
    performHealthCheck();
    const intervalId = setInterval(performHealthCheck, 60 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [displayId, accessToken, performHealthCheck]);

  useEffect(() => {
    if (assignedlayout.length > 0 || assignmentContainers.length > 0) {
      validateMainLayoutRequirements();
    }
  }, [assignedlayout, assignmentContainers, validateMainLayoutRequirements]);

  useEffect(() => {
    if (showModal) {
      validateMainLayoutRequirements();
    }
  }, [showModal, validateMainLayoutRequirements]);

  return (
    <div className="displays-bg-container">
      <Row className="p-2 align-items-center">
        <Col
          md={6}
          className="d-flex align-items-center gap-2"
          style={{ width: "auto", height: "50px" }}
        >
          {isEditingName ? (
            <>
              <input
                type="text"
                value={newDisplayName}
                onChange={(e) => setNewDisplayName(e.target.value)}
                className="px-2 py-[3px] mr-2 border tw-rounded-sm"
                style={{ width: "auto", outline: "2px solid #0D6EFD" }}
                autoFocus
              />
              <Button
                onClick={handleUpdateName}
                icon={<AiOutlineCheck />}
                size="small"
                className="mr-1"
                title="Save"
              ></Button>
              <Button
                onClick={handleNameCancel}
                icon={<AiOutlineClose />}
                size="small"
                title="Cancel"
              ></Button>
            </>
          ) : (
            <>
              <h6 className="mb-0 mr-2">
                Display Details - {newDisplayName || ""}
              </h6>
              <Button
                onClick={handleEditNameStart}
                icon={<BsPencilSquare />}
                size="small"
                title="Edit"
              ></Button>
            </>
          )}
        </Col>
      </Row>

      <div className="mt-4 image-content-container ">
        <div className="cards-image-display">
          <div key={displayId} style={{ width: "100%" }}>
            <div className="tv-btn-box">
              <div className="monitor-image-container">
                {screenshotImage && !error ? (
                  <>
                    {isImageLoading && (
                      <div className="tw-text-white/70 px-2">Loading...</div>
                    )}
                    <img
                      className="image-display !tw-object-cover !tw-object-top"
                      src={`${screenShotPath}?t=${Date.now()}`}
                      alt=""
                      style={{ display: isImageLoading ? "none" : "block" }}
                      onLoad={() => setIsImageLoading(false)}
                    />
                  </>
                ) : null}
              </div>

              <div className="all-button-container">
                {/* Restart Button */}
                <Tooltip title="Restart" color="#0071ca">
                  <div
                    className="button-container mb-0"
                    style={{ marginTop: "5px" }}
                  >
                    <CustomButton
                      disabledButton={false}
                      btnType="button"
                      BtnClassName={`custom-tv-btn $-btn`}
                      ClickEvent={(e) => clickToSendNotification("Restart")}
                      BtnTxt={<IoMdPower />}
                    />
                  </div>
                </Tooltip>

                {/* Screenshot Button */}
                <Tooltip
                  title="Take Screenshot (Page will reload after capture)"
                  color="#0071ca"
                >
                  <div className="button-container">
                    <CustomButton
                      disabledButton={isScreenshotLoading}
                      btnType="button"
                      BtnClassName="custom-tv-btn"
                      ClickEvent={handleTakeScreenshot}
                      BtnTxt={
                        <>
                          {isScreenshotLoading ? (
                            <MdOutlineRefresh className="tw-animate-spin tw-mt-2" />
                          ) : (
                            <MdOutlineCameraAlt />
                          )}
                        </>
                      }
                    />
                  </div>
                </Tooltip>

                {/* Health Button */}
                <Tooltip title="Health" color="#0071ca">
                  <div className="button-container ">
                    <CustomButton
                      disabledButton={false}
                      btnType="button"
                      BtnClassName="custom-tv-btn"
                      ClickEvent={(e) => clickToSendNotification("Checkin")}
                      BtnTxt={
                        <>
                          <BsHeartPulse />
                        </>
                      }
                      color={buttonColor}
                    />
                  </div>
                </Tooltip>

                {/* Edit Button */}
                <Tooltip title="Edit" color="#0071ca">
                  <div className="button-container mb-0">
                    <CustomButton
                      disabledButton={false}
                      btnType="button"
                      BtnClassName="custom-tv-btn "
                      ClickEvent={handleShow}
                      BtnTxt={
                        <>
                          <MdEditDocument />
                        </>
                      }
                    />
                  </div>
                </Tooltip>

                {/* Refresh Button */}
                <Tooltip title="Refresh" color="#0071ca">
                  <div className="button-container mb-0">
                    <CustomButton
                      disabledButton={false}
                      btnType="button"
                      BtnClassName="custom-tv-btn "
                      ClickEvent={(e) => clickToSendNotification("Refresh")}
                      BtnTxt={
                        <>
                          <MdOutlineRefresh />
                        </>
                      }
                    />
                  </div>
                </Tooltip>

                {/* Delete Button */}
                <Tooltip title="Delete" color="#0071ca">
                  <div className="button-container mb-0">
                    <CustomButton
                      disabledButton={false}
                      btnType="button"
                      BtnClassName="custom-tv-btn"
                      BtnTxt={
                        <>
                          <MdDelete />
                        </>
                      }
                    />
                  </div>
                </Tooltip>

                {/* Edit Location Button */}
                <Tooltip title="Location" color="#0071ca">
                  <div className="button-container mb-0">
                    <CustomButton
                      disabledButton={false}
                      btnType="button"
                      BtnClassName="custom-tv-btn "
                      BtnTxt={
                        <>
                          <MdLocationOn />
                        </>
                      }
                      ClickEvent={() => setShowLocationModal(true)}
                    />
                  </div>
                </Tooltip>
                <Modal
                  show={showLocationModal}
                  onHide={() => setShowLocationModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Select Location</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Select
                      value={selectedLocation}
                      onChange={(e) => handleLocationChange(e.target.value)}
                    >
                      <option value="">Select Location</option>
                      {locationData
                        .filter((location) => location.id !== selectedLocation)
                        .map((location) => (
                          <option key={location.id} value={location.name}>
                            {location.name}
                          </option>
                        ))}
                    </Form.Select>
                  </Modal.Body>
                  <Modal.Footer style={{ background: "#fff" }}>
                    <Button
                      variant="secondary"
                      onClick={() => setShowLocationModal(false)}
                    >
                      Close
                    </Button>
                    <Button variant="primary" onClick={handleSaveLocation}>
                      Save Location
                    </Button>
                  </Modal.Footer>
                </Modal>

                {/* Setting */}
                <DisplaySettings
                  notificationStatus={notificationStatus}
                  setNotificationStatus={setNotificationStatus}
                  displayId={displayId}
                  accessToken={accessToken}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="preview-add-layout-search-container">
        <div className="preview-search-input-container-lay ">
          <AiOutlineSearch style={{ fontSize: "23px" }} />
          <input
            type="text"
            className="search-input"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="mt-3 mb-3">
        {loadingLogs ? (
          <Skeleton count={5} height={40} />
        ) : (
          <CustomDataTable
            columns={columns}
            data={displayLogs}
            tableKey="displayLogsTable"
            forceFixedLayout
          />
        )}
      </div>

      <Modal
        className="custom-modal-size"
        centered
        show={showModal}
        backdrop="static"
        onHide={handleClose}
      >
        <Modal.Header
          closeButton
          style={{
            border: " 1px solid #D9D9D9",
          }}
        >
          <Modal.Title className="text-center">
            <div className="display-assignment-modl ">
              <h6 className="headingmodal">
                Update Assignments for {location} Display
              </h6>
              <p className="paramodal">
                Please update assignments below and click 'Next' for Summary
              </p>

              <CustomButton
                disabledButton={false}
                btnType="button"
                BtnClassName="add-assignment-buttons tw-mt-2"
                BtnTxt={<>Add Assignments</>}
                ClickEvent={addAssignmentContainer}
              />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            ref={modalBodyRef}
            className="body-modal"
            style={{
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
              maxHeight: "70vh",
            }}
          >
            {assignedlayout && assignmentContainers && (
              <>
                <div
                  style={{
                    order: assignmentContainers.some((c) => c.isAlldayEnabled)
                      ? 2
                      : 1,
                  }}
                >
                  {assignedlayout && assignedlayout.length > 0
                    ? assignedlayout.map((assignment, layoutIndex) => (
                        <div
                          key={assignment.id || `assignment_${layoutIndex}`}
                          style={{ position: "relative" }}
                        >
                          {layoutIndex < assignedlayout.length && (
                            <button
                              className="xbtn"
                              onClick={() => {
                                handlePlusModalShow(
                                  assignment.layoutId,
                                  layoutIndex
                                );
                              }}
                            >
                              X
                            </button>
                          )}

                          <div
                            className={`display-pop-container ${
                              assignment.isAlldayEnabled && isMainLayoutShrinked
                                ? "main-layout-shrinked tw-fixed tw-max-w-[615px] tw-z-50 tw-bg-green-50 tw-border-green-500"
                                : assignment.isAlldayEnabled
                                ? "main-layout tw-border-blue-500 tw-bg-blue-50"
                                : ""
                            }`}
                            key={
                              assignment.id || `newAssignment_${layoutIndex}`
                            }
                            onClick={() => {
                              if (
                                assignment.isAlldayEnabled &&
                                isMainLayoutShrinked
                              ) {
                                setIsMainLayoutShrinked(false);
                              }
                            }}
                            style={{
                              cursor:
                                assignment.isAlldayEnabled &&
                                isMainLayoutShrinked
                                  ? "pointer"
                                  : "default",
                              marginTop:
                                !assignment.isAlldayEnabled &&
                                isMainLayoutShrinked &&
                                layoutIndex ===
                                  assignedlayout.findIndex(
                                    (layout) => !layout.isAlldayEnabled
                                  )
                                  ? "90px"
                                  : "0px",
                            }}
                          >
                            <div>
                              {libraryIds &&
                              libraryIds.length >= layoutIndex + 1 &&
                              libraryIds[layoutIndex].length > 0 ? (
                                (() => {
                                  const currentLayoutItems =
                                    libraryIds[layoutIndex];
                                  const imageItems = currentLayoutItems.filter(
                                    (item) => {
                                      if (!item || !item.fileUrl) return false;
                                      const hasValidMediaType =
                                        item.mediaType === "image" ||
                                        (!item.mediaType &&
                                          /\.(jpg|jpeg|png|webp|avif|gif|bmp|tiff|ico)$/i.test(
                                            item.fileUrl
                                          ));
                                      const hasValidExtension =
                                        /\.(jpg|jpeg|png|webp|avif|gif|bmp|tiff|ico)$/i.test(
                                          item.fileUrl
                                        );
                                      return (
                                        hasValidMediaType && hasValidExtension
                                      );
                                    }
                                  );

                                  if (imageItems.length === 0) {
                                    return (
                                      <img
                                        className="modalpic"
                                        src={imageUrl}
                                        alt=".."
                                      />
                                    );
                                  }

                                  // Handle single image - no stacking needed
                                  if (imageItems.length === 1) {
                                    return (
                                      <img
                                        className="modalpic"
                                        src={imageItems[0].fileUrl}
                                        alt=".."
                                      />
                                    );
                                  }

                                  // Handle multiple images - use proper stacking
                                  return (
                                    <div
                                      className={`tw-relative tw-h-64 ${
                                        assignment.isAlldayEnabled &&
                                        isMainLayoutShrinked &&
                                        "tw-w-[65px]"
                                      } tw-flex tw-justify-center tw-items-center`}
                                    >
                                      {imageItems
                                        .slice()
                                        .reverse()
                                        .slice(0, 5) // Show at least 5 images for preview
                                        .map((image, imageIndex) => (
                                          <img
                                            key={
                                              image.id ||
                                              `preview_image_${imageIndex}`
                                            }
                                            className="modalpic image-stack-item"
                                            src={image.fileUrl}
                                            alt=".."
                                            style={{
                                              position: "absolute",
                                            }}
                                          />
                                        ))}
                                    </div>
                                  );
                                })()
                              ) : (
                                <img
                                  className="modalpic"
                                  src={imageUrl}
                                  alt=".."
                                />
                              )}
                              <div className="d-flex tw-space-x-2 mt-2">
                                <p className="tw-text-[14px]">
                                  Global base layout
                                </p>
                                <Switch
                                  checked={assignment.isAlldayEnabled}
                                  onChange={(checked) => {
                                    // Calculate new state for assignments
                                    const newAssignments = assignedlayout.map(
                                      (layout, idx) => {
                                        if (idx === layoutIndex) {
                                          // Update current layout
                                          const updated = {
                                            ...layout,
                                            isAlldayEnabled: checked,
                                          };
                                          if (checked) {
                                            return {
                                              ...updated,
                                              startTime: "00:00",
                                              endTime: "23:59",
                                              selectedDays: [
                                                0, 1, 2, 3, 4, 5, 6,
                                              ],
                                              isDateRangeEnabled: false,
                                              startDate: null,
                                              endDate: null,
                                            };
                                          }
                                          return updated;
                                        } else {
                                          // Disable other layouts if enabling current one
                                          return {
                                            ...layout,
                                            isAlldayEnabled:
                                              checked && !multiple
                                                ? false
                                                : layout.isAlldayEnabled,
                                          };
                                        }
                                      }
                                    );

                                    // Calculate new state for containers
                                    const newContainers =
                                      assignmentContainers.map((container) => ({
                                        ...container,
                                        isAlldayEnabled:
                                          checked && !multiple
                                            ? false
                                            : container.isAlldayEnabled,
                                      }));

                                    // Reorder if enabling
                                    const finalAssignments = checked
                                      ? moveItem(newAssignments, layoutIndex, 0)
                                      : newAssignments;

                                    // Update all state
                                    setAssignedlayout(finalAssignments);
                                    setAssignmentContainers(newContainers);

                                    if (checked) {
                                      setLibraryIds((prev) =>
                                        moveItem(prev, layoutIndex, 0)
                                      );
                                      scrollModalToTopSmooth();
                                      setIsMainLayoutShrinked(false);
                                    }
                                  }}
                                  className={`${
                                    assignment.isAlldayEnabled
                                      ? "bg-blue-600"
                                      : "bg-gray-200"
                                  }
              relative inline-flex h-6 w-11 items-center rounded-full`}
                                >
                                  <span
                                    className={`${
                                      assignment.isAlldayEnabled
                                        ? "translate-x-6"
                                        : "translate-x-1"
                                    }
              inline-block h-4 w-4 transform rounded-full bg-white transition`}
                                  />
                                </Switch>
                              </div>
                              <p className="tw-text-[12px] tw-text-[#828282]">
                                {assignment.isAlldayEnabled
                                  ? "This layout plays continuously for 24 hours. Time and day settings are disabled."
                                  : "Enable 'Global base layout' to play continuously for 24 hours, or keep as scheduled layout."}
                              </p>
                            </div>
                            <div>
                              <div className="dropdown-container mt-2">
                                <label
                                  htmlFor={`layoutName${layoutIndex}`}
                                  className="dropdown-label"
                                >
                                  Layout Name
                                </label>
                                <select
                                  id={`layoutName${layoutIndex}`}
                                  name={`layoutName${layoutIndex}`}
                                  className="dropdown-select"
                                  value={assignment.layoutId}
                                  onChange={(e) => {
                                    const updatedAssignments = [
                                      ...assignedlayout,
                                    ];
                                    updatedAssignments[layoutIndex].layoutId =
                                      e.target.value;
                                    updatedAssignments[layoutIndex].name =
                                      e.target.options[
                                        e.target.selectedIndex
                                      ].text;
                                    setAssignedlayout(updatedAssignments);
                                    setError("");
                                  }}
                                >
                                  <option value={assignment.layoutId}>
                                    {assignment.name}
                                  </option>
                                  {layoutArr
                                    .filter(
                                      (eachItem) =>
                                        eachItem.id !== assignment.layoutId
                                    )
                                    .map((filteredItem) => (
                                      <option
                                        key={filteredItem.id}
                                        value={filteredItem.id}
                                      >
                                        {filteredItem.name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <br />
                              <div>
                                <label htmlFor="start-time">
                                  Set time limit to play this layout
                                </label>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "40px",
                                    margin: "10px",
                                  }}
                                >
                                  <div
                                    id={`start-time-${layoutIndex}`}
                                    style={{
                                      cursor: assignment.isAlldayEnabled
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  >
                                    <LocalizationProvider
                                      dateAdapter={AdapterMoment}
                                    >
                                      <TimePicker
                                        value={moment(
                                          assignment.startTime,
                                          "HH:mm"
                                        )}
                                        onChange={(newValue) => {
                                          const updatedAssignments = [
                                            ...assignedlayout,
                                          ];
                                          updatedAssignments[
                                            layoutIndex
                                          ].startTime =
                                            newValue.format("HH:mm");
                                          setAssignedlayout(updatedAssignments);
                                        }}
                                        views={["hours", "minutes"]}
                                        ampm={false}
                                        inputFormat="HH:mm"
                                        OpenPickerButtonProps={{
                                          style: { display: "none" },
                                        }}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                        disabled={assignment.isAlldayEnabled}
                                      />
                                    </LocalizationProvider>
                                  </div>

                                  <div
                                    id={`end-time-${layoutIndex}`}
                                    style={{
                                      cursor: assignment.isAlldayEnabled
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  >
                                    <LocalizationProvider
                                      dateAdapter={AdapterMoment}
                                    >
                                      <TimePicker
                                        value={moment(
                                          assignment.endTime,
                                          "HH:mm"
                                        )}
                                        onChange={(newValue) => {
                                          const updatedAssignments = [
                                            ...assignedlayout,
                                          ];
                                          updatedAssignments[
                                            layoutIndex
                                          ].endTime = newValue.format("HH:mm");
                                          setAssignedlayout(updatedAssignments);
                                          setError("");
                                        }}
                                        views={["hours", "minutes"]}
                                        ampm={false}
                                        inputFormat="HH:mm"
                                        OpenPickerButtonProps={{
                                          style: { display: "none" },
                                        }}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                        disabled={assignment.isAlldayEnabled}
                                      />
                                    </LocalizationProvider>
                                  </div>
                                </div>

                                <div className="mb-2">
                                  Choose days of the week
                                </div>
                                <div className="d-flex tw-justify-between mb-2">
                                  {days.map((day, dayIndex) => (
                                    <button
                                      key={dayIndex}
                                      disabled={assignment.isAlldayEnabled}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        position: "relative",
                                        opacity: assignment.isAlldayEnabled
                                          ? 0.5
                                          : 1,
                                        cursor: assignment.isAlldayEnabled
                                          ? "not-allowed"
                                          : "pointer",
                                      }}
                                      className={`tw-w-7 tw-h-7 tw-text-sm tw-rounded-full ${
                                        assignment.selectedDays.includes(
                                          dayIndex
                                        )
                                          ? "bg-primary text-white border border-primary"
                                          : "tw-bg-gray-100 text-primary border tw-rounded-full border-primary unselected"
                                      }`}
                                      onClick={() => {
                                        if (!assignment.isAlldayEnabled) {
                                          handleDayClickForAssigned(
                                            layoutIndex,
                                            dayIndex
                                          );
                                        }
                                      }}
                                    >
                                      {day}
                                    </button>
                                  ))}
                                </div>
                                <div className=" d-flex tw-justify-between ">
                                  <p className=" tw-text-[14px]">
                                    Set date range to play this layout
                                  </p>
                                  <Switch
                                    checked={assignment.isDateRangeEnabled}
                                    disabled={assignment.isAlldayEnabled}
                                    onChange={(checked) => {
                                      if (!assignment.isAlldayEnabled) {
                                        const updatedAssignments = [
                                          ...assignedlayout,
                                        ];
                                        updatedAssignments[
                                          layoutIndex
                                        ].isDateRangeEnabled = checked;

                                        if (!checked) {
                                          updatedAssignments[
                                            layoutIndex
                                          ].startDate = null;
                                          updatedAssignments[
                                            layoutIndex
                                          ].endDate = null;

                                          updatedAssignments[
                                            layoutIndex
                                          ].originalStartDate = null;
                                          updatedAssignments[
                                            layoutIndex
                                          ].originalEndDate = null;
                                        }

                                        setAssignedlayout(updatedAssignments);
                                      }
                                    }}
                                    className={`${
                                      assignment.isDateRangeEnabled
                                        ? "bg-blue-600"
                                        : "bg-gray-200"
                                    } ${
                                      assignment.isAlldayEnabled
                                        ? "opacity-50"
                                        : ""
                                    }
    relative inline-flex h-6 w-11 items-center rounded-full`}
                                  >
                                    <span
                                      className={`${
                                        assignment.isDateRangeEnabled
                                          ? "translate-x-6"
                                          : "translate-x-1"
                                      }
    inline-block h-4 w-4 transform rounded-full bg-white transition`}
                                    />
                                  </Switch>
                                </div>
                                {assignment.isDateRangeEnabled && (
                                  <div className="mt-3 d-flex gap-3">
                                    <div>
                                      <p className="tw-text-[14px] mb-2">
                                        Start Date
                                      </p>
                                      <DatePicker
                                        selected={
                                          assignment.startDate
                                            ? new Date(assignment.startDate)
                                            : null
                                        }
                                        disabled={assignment.isAlldayEnabled}
                                        onChange={(date) => {
                                          if (!assignment.isAlldayEnabled) {
                                            const updatedAssignments = [
                                              ...assignedlayout,
                                            ];
                                            updatedAssignments[
                                              layoutIndex
                                            ].startDate = date;
                                            setAssignedlayout(
                                              updatedAssignments
                                            );
                                          }
                                        }}
                                        dateFormat="dd-MM-yyyy"
                                        className={`form-control ${
                                          assignment.isAlldayEnabled
                                            ? "disabled-input"
                                            : ""
                                        }`}
                                        popperClassName="custom-datepicker-popper"
                                        popperPlacement="bottom-start"
                                        popperStyle={{ zIndex: 9999 }}
                                      />
                                    </div>
                                    <div>
                                      <p className="tw-text-[14px] mb-2">
                                        End Date
                                      </p>
                                      <DatePicker
                                        selected={
                                          assignment.endDate
                                            ? new Date(assignment.endDate)
                                            : null
                                        }
                                        disabled={
                                          assignment.isAlldayEnabled ||
                                          !assignment.startDate
                                        }
                                        onChange={(date) => {
                                          if (!assignment.isAlldayEnabled) {
                                            const updatedAssignments = [
                                              ...assignedlayout,
                                            ];
                                            updatedAssignments[
                                              layoutIndex
                                            ].endDate = date;
                                            setAssignedlayout(
                                              updatedAssignments
                                            );
                                          }
                                        }}
                                        dateFormat="dd-MM-yyyy"
                                        minDate={
                                          assignment.startDate
                                            ? new Date(assignment.startDate)
                                            : null
                                        }
                                        className={`form-control ${
                                          assignment.isAlldayEnabled
                                            ? "disabled-input"
                                            : ""
                                        }`}
                                        popperClassName="custom-datepicker-popper"
                                        popperPlacement="bottom-start"
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    : null}
                </div>
              </>
            )}

            <div
              style={{
                order: assignmentContainers.some((c) => c.isAlldayEnabled)
                  ? 1
                  : 2,
              }}
            >
              {assignmentContainers.map((assignmentContainer, index) => {
                return (
                  <div
                    key={assignmentContainer.id || `container_${index}`}
                    style={{ position: "relative" }}
                  >
                    <div
                      className={`display-pop-container ${
                        assignmentContainer.isAlldayEnabled &&
                        isMainLayoutShrinked
                          ? "main-layout-shrinked tw-fixed tw-max-w-[615px] tw-z-50 tw-bg-green-50 tw-border-green-500"
                          : assignmentContainer.isAlldayEnabled
                          ? "main-layout tw-border-blue-500 tw-bg-blue-50"
                          : ""
                      }`}
                      key={assignmentContainer.id}
                      onClick={() => {
                        if (
                          assignmentContainer.isAlldayEnabled &&
                          isMainLayoutShrinked
                        ) {
                          setIsMainLayoutShrinked(false);
                        }
                      }}
                      style={{
                        cursor:
                          assignmentContainer.isAlldayEnabled &&
                          isMainLayoutShrinked
                            ? "pointer"
                            : "default",
                        marginTop:
                          !assignmentContainer.isAlldayEnabled &&
                          isMainLayoutShrinked &&
                          index ===
                            assignmentContainers.findIndex(
                              (container) => !container.isAlldayEnabled
                            ) &&
                          !assignedlayout.some(
                            (layout) => !layout.isAlldayEnabled
                          )
                            ? "90px"
                            : "0px",
                      }}
                    >
                      <div>
                        <button
                          className="xbtn"
                          onClick={() => {
                            const updatedAssignments =
                              assignmentContainers.filter(
                                (_, i) => i !== index
                              );
                            setAssignmentContainers(updatedAssignments);
                          }}
                        >
                          X
                        </button>
                        {assignmentContainer.layoutId ? (
                          (() => {
                            const selectedLayout = layoutArr.find(
                              (layout) =>
                                layout.id === assignmentContainer.layoutId
                            );
                            if (selectedLayout?.libraryIds) {
                              try {
                                const parsedLibraryIds = JSON.parse(
                                  selectedLayout.libraryIds
                                );
                                if (parsedLibraryIds.length > 0) {
                                  // Filter for images with more robust logic
                                  const layoutImages = parsedLibraryIds.filter(
                                    (item) => {
                                      // Check if item has required properties
                                      if (!item || !item.fileUrl) return false;

                                      // Check media type - be more flexible
                                      const hasValidMediaType =
                                        item.mediaType === "image" ||
                                        (!item.mediaType &&
                                          /\.(jpg|jpeg|png|webp|avif|gif|bmp|tiff|ico)$/i.test(
                                            item.fileUrl
                                          ));

                                      // Check file extension - case insensitive
                                      const hasValidExtension =
                                        /\.(jpg|jpeg|png|webp|avif|gif|bmp|tiff|ico)$/i.test(
                                          item.fileUrl
                                        );

                                      return (
                                        hasValidMediaType && hasValidExtension
                                      );
                                    }
                                  );
                                  if (layoutImages.length > 0) {
                                    // Handle single image - no stacking needed
                                    if (layoutImages.length === 1) {
                                      return (
                                        <div className="tw-flex tw-justify-center tw-items-center">
                                          <img
                                            key={
                                              layoutImages[0].id ||
                                              "single_image"
                                            }
                                            className="modalpic"
                                            src={layoutImages[0].fileUrl}
                                            alt=".."
                                          />
                                        </div>
                                      );
                                    }

                                    // Handle multiple images - use proper stacking
                                    return (
                                      <div className="tw-p-8 tw-relative tw-h-64 tw-flex tw-justify-center tw-items-center">
                                        {layoutImages
                                          .slice()
                                          .reverse()
                                          .slice(0, 5) // Show at least 5 images for preview
                                          .map((image, imageIndex) => (
                                            <img
                                              key={
                                                image.id ||
                                                `image_${imageIndex}`
                                              }
                                              className="modalpic image-stack-item"
                                              src={image.fileUrl}
                                              alt=".."
                                              style={{
                                                position: "absolute",
                                              }}
                                            />
                                          ))}
                                      </div>
                                    );
                                  }
                                }
                              } catch (error) {
                                console.error(
                                  "Error parsing libraryIds:",
                                  error
                                );
                              }
                            }
                            return (
                              <img
                                className="modalpic"
                                src={imageUrl}
                                alt=".."
                              />
                            );
                          })()
                        ) : (
                          <img className="modalpic" src={imageUrl} alt=".." />
                        )}
                        <div className="d-flex tw-space-x-2 mt-2">
                          <p className="tw-text-[14px]">Global base layout</p>
                          <Switch
                            checked={assignmentContainer.isAlldayEnabled}
                            onChange={(checked) => {
                              // Calculate new state for containers
                              const newContainers = assignmentContainers.map(
                                (container, idx) => {
                                  if (idx === index) {
                                    // Update current container
                                    const updated = {
                                      ...container,
                                      isAlldayEnabled: checked,
                                    };
                                    if (checked) {
                                      return {
                                        ...updated,
                                        selectedStartTime: "00:00",
                                        selectedEndTime: "23:59",
                                        selectedDays: [0, 1, 2, 3, 4, 5, 6],
                                        isDateRangeEnabled: false,
                                        startDate: null,
                                        endDate: null,
                                      };
                                    }
                                    return updated;
                                  } else {
                                    // Disable other containers if enabling current one
                                    return {
                                      ...container,
                                      isAlldayEnabled:
                                        checked && !multiple
                                          ? false
                                          : container.isAlldayEnabled,
                                    };
                                  }
                                }
                              );

                              // Calculate new state for assignments
                              const newAssignments = assignedlayout.map(
                                (assignment) => ({
                                  ...assignment,
                                  isAlldayEnabled:
                                    checked && !multiple
                                      ? false
                                      : assignment.isAlldayEnabled,
                                })
                              );

                              // Reorder if enabling
                              const finalContainers = checked
                                ? moveItem(newContainers, index, 0)
                                : newContainers;

                              // Update all state
                              setAssignmentContainers(finalContainers);
                              setAssignedlayout(newAssignments);

                              if (checked) {
                                scrollModalToTopSmooth();
                                setIsMainLayoutShrinked(false);
                              }
                            }}
                            className={`${
                              assignmentContainer.isAlldayEnabled
                                ? "bg-blue-600"
                                : "bg-gray-200"
                            } 
      relative inline-flex h-6 w-11 items-center rounded-full`}
                          >
                            <span
                              className={`${
                                assignmentContainer.isAlldayEnabled
                                  ? "translate-x-6"
                                  : "translate-x-1"
                              }
      inline-block h-4 w-4 transform rounded-full bg-white transition`}
                            />
                          </Switch>
                        </div>
                        <p className=" tw-text-[12px] tw-text-[#828282]">
                          {assignmentContainer.isAlldayEnabled
                            ? "This layout plays continuously for 24 hours. Time and day settings are disabled."
                            : "Enable 'Global base layout' to play continuously for 24 hours, or keep as scheduled layout."}
                        </p>
                      </div>

                      <div>
                        <div className="dropdown-container mt-2">
                          <label
                            htmlFor={`layoutName${index}`}
                            className="dropdown-label"
                          >
                            Layout Name
                          </label>
                          <select
                            id={`layoutName${index}`}
                            name={`layoutName${index}`}
                            className="dropdown-select"
                            value={assignmentContainer.layoutId}
                            onChange={(e) => {
                              const selectedLayoutId = e.target.value;

                              // Update the container with the selected layout
                              const updatedContainers = [
                                ...assignmentContainers,
                              ];
                              updatedContainers[index].layoutId =
                                selectedLayoutId;
                              setAssignmentContainers(updatedContainers);
                            }}
                          >
                            <option value="">Select Layout</option>
                            {layoutArr.length > 0 &&
                              layoutArr.map((layout) => (
                                <option key={layout.id} value={layout.id}>
                                  {layout.name}
                                </option>
                              ))}
                          </select>
                        </div>
                        <br />
                        <div>
                          <label htmlFor="start-time">
                            Set time limit to play this layout
                          </label>
                          <div
                            style={{
                              display: "flex",
                              gap: "40px",
                              margin: "10px",
                            }}
                          >
                            <div
                              id={`start-time-${index}`}
                              style={{
                                cursor: assignmentContainer.isAlldayEnabled
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            >
                              <LocalizationProvider dateAdapter={AdapterMoment}>
                                <TimePicker
                                  value={moment(
                                    assignmentContainer.selectedStartTime,
                                    "HH:mm"
                                  )}
                                  onChange={(newValue) => {
                                    const updatedContainers = [
                                      ...assignmentContainers,
                                    ];
                                    updatedContainers[index].selectedStartTime =
                                      newValue.format("HH:mm");
                                    setAssignmentContainers(updatedContainers);
                                    setError("");
                                  }}
                                  views={["hours", "minutes"]}
                                  ampm={false}
                                  inputFormat="HH:mm"
                                  OpenPickerButtonProps={{
                                    style: { display: "none" },
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      sx={{
                                        "& .MuiInputBase-root": {
                                          padding: "4px",
                                        },
                                        "& .MuiInputBase-input": {
                                          fontSize: "14px",
                                          padding: "4px 8px",
                                        },
                                        "& .MuiSvgIcon-root": {
                                          fontSize: "20px",
                                          marginRight: "4px",
                                        },
                                      }}
                                    />
                                  )}
                                  disabled={assignmentContainer.isAlldayEnabled}
                                />
                              </LocalizationProvider>
                            </div>

                            <div
                              id={`end-time-${index}`}
                              style={{
                                cursor: assignmentContainer.isAlldayEnabled
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            >
                              <LocalizationProvider dateAdapter={AdapterMoment}>
                                <TimePicker
                                  value={moment(
                                    assignmentContainer.selectedEndTime,
                                    "HH:mm"
                                  )}
                                  onChange={(newValue) => {
                                    const updatedContainers = [
                                      ...assignmentContainers,
                                    ];
                                    updatedContainers[index].selectedEndTime =
                                      newValue.format("HH:mm");
                                    setAssignmentContainers(updatedContainers);
                                    setError("");
                                  }}
                                  views={["hours", "minutes"]}
                                  ampm={false}
                                  inputFormat="HH:mm"
                                  OpenPickerButtonProps={{
                                    style: { display: "none" },
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      sx={{
                                        "& .MuiInputBase-root": {
                                          padding: "4px",
                                        },
                                        "& .MuiInputBase-input": {
                                          fontSize: "14px",
                                          padding: "4px 8px",
                                        },
                                        "& .MuiSvgIcon-root": {
                                          fontSize: "20px",
                                          marginRight: "4px",
                                        },
                                      }}
                                    />
                                  )}
                                  disabled={assignmentContainer.isAlldayEnabled}
                                />
                              </LocalizationProvider>
                            </div>
                          </div>

                          <div className="mb-2">Choose days of the week</div>
                          <div className="d-flex tw-justify-between mb-2">
                            {days.map((day, dayIndex) => {
                              const isInDateRange =
                                assignmentContainer.selectedDays.includes(
                                  dayIndex
                                );

                              return (
                                <button
                                  key={dayIndex}
                                  disabled={assignmentContainer.isAlldayEnabled}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    position: "relative",
                                    opacity: assignmentContainer.isAlldayEnabled
                                      ? 0.5
                                      : 1,
                                    cursor: assignmentContainer.isAlldayEnabled
                                      ? "not-allowed"
                                      : "pointer",
                                  }}
                                  className={`tw-w-7 tw-h-7 tw-text-sm tw-rounded-full ${
                                    isInDateRange
                                      ? "bg-primary text-white border border-primary"
                                      : "tw-bg-gray-100 text-primary border border-primary unselected"
                                  }`}
                                  onClick={() => {
                                    if (assignmentContainer.isAlldayEnabled)
                                      return;

                                    const updatedContainers = [
                                      ...assignmentContainers,
                                    ];
                                    const currentDays =
                                      updatedContainers[index].selectedDays;

                                    if (currentDays.includes(dayIndex)) {
                                      updatedContainers[index].selectedDays =
                                        currentDays.filter(
                                          (d) => d !== dayIndex
                                        );
                                    } else {
                                      updatedContainers[index].selectedDays = [
                                        ...currentDays,
                                        dayIndex,
                                      ];
                                    }
                                    setAssignmentContainers(updatedContainers);
                                  }}
                                >
                                  {day}
                                </button>
                              );
                            })}
                          </div>
                          <div className=" d-flex tw-justify-between ">
                            <p className=" tw-text-[14px]">
                              Set date range to play this layout
                            </p>
                            <Switch
                              checked={assignmentContainer.isDateRangeEnabled}
                              disabled={assignmentContainer.isAlldayEnabled}
                              onChange={(checked) => {
                                if (!assignmentContainer.isAlldayEnabled) {
                                  const updatedContainers = [
                                    ...assignmentContainers,
                                  ];
                                  updatedContainers[index].isDateRangeEnabled =
                                    checked;

                                  if (!checked) {
                                    updatedContainers[index].startDate = null;
                                    updatedContainers[index].endDate = null;

                                    updatedContainers[index].originalStartDate =
                                      null;
                                    updatedContainers[index].originalEndDate =
                                      null;
                                  }

                                  setAssignmentContainers(updatedContainers);
                                }
                              }}
                              className={`${
                                assignmentContainer.isDateRangeEnabled
                                  ? "bg-blue-600"
                                  : "bg-gray-200"
                              } ${
                                assignmentContainer.isAlldayEnabled
                                  ? "opacity-50"
                                  : ""
                              } relative inline-flex h-6 w-11 items-center rounded-full`}
                            >
                              <span
                                className={`${
                                  assignmentContainer.isDateRangeEnabled
                                    ? "translate-x-6"
                                    : "translate-x-1"
                                } inline-block h-4 w-4 transform rounded-full bg-white transition`}
                              />
                            </Switch>
                          </div>
                          {assignmentContainer.isDateRangeEnabled && (
                            <div className="mt-3 d-flex gap-3">
                              <div className="">
                                <p className="tw-text-[14px] mb-2">
                                  Start Date
                                </p>
                                <DatePicker
                                  selected={
                                    assignmentContainer.startDate
                                      ? new Date(assignmentContainer.startDate)
                                      : null
                                  }
                                  disabled={assignmentContainer.isAlldayEnabled}
                                  onChange={(date) => {
                                    if (!assignmentContainer.isAlldayEnabled) {
                                      const updatedContainers = [
                                        ...assignmentContainers,
                                      ];
                                      updatedContainers[index].startDate = date;
                                      setAssignmentContainers(
                                        updatedContainers
                                      );
                                    }
                                  }}
                                  selectsStart
                                  startDate={assignmentContainer.startDate}
                                  endDate={assignmentContainer.endDate}
                                  dateFormat="dd-MM-yyyy"
                                  placeholderText="Select start date"
                                  className={`form-control tw-w-full ${
                                    assignmentContainer.isAlldayEnabled
                                      ? "disabled-input"
                                      : ""
                                  }`}
                                  calendarClassName="custom-calendar"
                                  popperClassName="custom-datepicker-popper"
                                  popperPlacement="bottom-start"
                                />
                              </div>
                              <div>
                                <p className="tw-text-[14px] mb-2">End Date</p>
                                <DatePicker
                                  selected={
                                    assignmentContainer.endDate
                                      ? new Date(assignmentContainer.endDate)
                                      : null
                                  }
                                  disabled={
                                    assignmentContainer.isAlldayEnabled ||
                                    !assignmentContainer.startDate
                                  }
                                  onChange={(date) => {
                                    if (!assignmentContainer.isAlldayEnabled) {
                                      const updatedContainers = [
                                        ...assignmentContainers,
                                      ];
                                      updatedContainers[index].endDate = date;
                                      setAssignmentContainers(
                                        updatedContainers
                                      );
                                    }
                                  }}
                                  selectsEnd
                                  startDate={assignmentContainer.startDate}
                                  endDate={assignmentContainer.endDate}
                                  minDate={assignmentContainer.startDate}
                                  dateFormat="dd-MM-yyyy"
                                  placeholderText="Select end date"
                                  className={`form-control tw-w-full ${
                                    assignmentContainer.isAlldayEnabled
                                      ? "disabled-input"
                                      : ""
                                  }`}
                                  calendarClassName="custom-calendar"
                                  popperClassName="custom-datepicker-popper"
                                  popperPlacement="bottom-start"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {layoutValidationWarnings.length > 0 && (
            <div>
              {layoutValidationWarnings.map((warning, index) => (
                <div
                  key={index}
                  style={{
                    fontSize: "14px",
                    padding: "10px 15px",
                    borderRadius: "6px",
                    border: `1px solid ${
                      warning.type === "error"
                        ? "#f5c6cb"
                        : warning.type === "success"
                        ? "#c3e6cb"
                        : "#ffeaa7"
                    }`,
                    backgroundColor:
                      warning.type === "error"
                        ? "#f8d7da"
                        : warning.type === "success"
                        ? "#d4edda"
                        : "#fff3cd",
                    color:
                      warning.type === "error"
                        ? "#721c24"
                        : warning.type === "success"
                        ? "#155724"
                        : "#856404",
                  }}
                >
                  <strong>
                    {warning.type === "error"
                      ? "⚠️ "
                      : warning.type === "success"
                      ? "✅ "
                      : "ℹ️ "}
                  </strong>
                  {warning.message}
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={{ background: "#fff" }}>
          <div className="savebtn-contaier">
            <CustomButton
              disabledButton={!isValidationPassed}
              btnType="button"
              BtnClassName={`add-layout-buttons ${
                !isValidationPassed ? "disabled-button" : ""
              }`}
              BtnTxt={<>Next</>}
              ClickEvent={handleNextToSummary}
            />
          </div>
        </Modal.Footer>
      </Modal>

      {/* Summary Modal */}
      <Modal
        className="custom-modal-size"
        animation
        show={showSummaryModal}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Layout Schedule Summary
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="body-modal"
            style={{
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
              maxHeight: "70vh",
            }}
          >
            {/* Layout Summary Section */}
            {(assignedlayout.length > 0 ||
              assignmentContainers.some((c) => c.layoutId)) && (
              <div style={{ marginBottom: "20px" }}>
                <div
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "12px",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                  }}
                >
                  {generateLayoutSummary().map((layout, index) => (
                    <div
                      key={`${layout.id}_${index}`}
                      style={{
                        padding: "16px 20px",
                        borderBottom:
                          index < generateLayoutSummary().length - 1
                            ? "1px solid #f0f0f0"
                            : "none",
                        backgroundColor: layout.isAlldayEnabled
                          ? "#f8f9ff"
                          : "#fff",
                        borderLeft: layout.isAlldayEnabled
                          ? "4px solid #4285f4"
                          : "4px solid transparent",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "20px",
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              marginBottom: "8px",
                            }}
                          >
                            <h6
                              style={{
                                margin: 0,
                                fontSize: "16px",
                                fontWeight: "600",
                                color: layout.isAlldayEnabled
                                  ? "#4285f4"
                                  : "#333",
                              }}
                            >
                              {layout.name}
                            </h6>
                            {layout.isAlldayEnabled && (
                              <span
                                style={{
                                  fontSize: "11px",
                                  backgroundColor: "#4285f4",
                                  color: "white",
                                  padding: "2px 8px",
                                  borderRadius: "12px",
                                  fontWeight: "500",
                                }}
                              >
                                GLOBAL BASE
                              </span>
                            )}
                            {layout.type === "new" && (
                              <span
                                style={{
                                  fontSize: "11px",
                                  backgroundColor: "#28a745",
                                  color: "white",
                                  padding: "2px 8px",
                                  borderRadius: "12px",
                                  fontWeight: "500",
                                }}
                              >
                                NEW
                              </span>
                            )}
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "16px",
                              fontSize: "14px",
                              color: "#666",
                              marginBottom: "12px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <span>🕒</span>
                              <span style={{ fontWeight: "500" }}>
                                {layout.timeRange}
                              </span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <span>📅</span>
                              <span style={{ fontWeight: "500" }}>
                                {layout.dayNames || "No days selected"}
                              </span>
                            </div>

                            {layout.isDateRangeEnabled && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                <span>📆</span>
                                <span style={{ fontWeight: "500" }}>
                                  {layout.dateRange}
                                </span>
                              </div>
                            )}
                          </div>

                          {/* Detailed Description */}
                          <div
                            style={{
                              backgroundColor: layout.isAlldayEnabled
                                ? "rgba(66, 133, 244, 0.1)"
                                : "rgba(0, 0, 0, 0.05)",
                              padding: "12px",
                              borderRadius: "8px",
                              fontSize: "13px",
                              lineHeight: "1.5",
                              color: "#555",
                              marginTop: "8px",
                              border: layout.isAlldayEnabled
                                ? "1px solid rgba(66, 133, 244, 0.2)"
                                : "1px solid rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "8px",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  flexShrink: 0,
                                  marginTop: "1px",
                                }}
                              >
                                💡
                              </span>
                              <span
                                style={{
                                  flex: 1,
                                  wordBreak: "break-word",
                                  whiteSpace: "normal",
                                }}
                              >
                                {layout.detailedDescription}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {generateLayoutSummary().length === 0 && (
                    <div
                      style={{
                        padding: "40px 20px",
                        textAlign: "center",
                        color: "#666",
                        fontSize: "14px",
                      }}
                    >
                      <div style={{ fontSize: "32px", marginBottom: "12px" }}>
                        📋
                      </div>
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          marginBottom: "8px",
                          color: "#333",
                        }}
                      >
                        No Schedule Configured
                      </div>
                      <div
                        style={{
                          maxWidth: "300px",
                          margin: "0 auto",
                          lineHeight: "1.5",
                        }}
                      >
                        Add layout assignments above to see a detailed schedule
                        summary showing when each layout will play.
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ background: "#fff" }}>
          <div className="d-flex justify-content-between w-100">
            <CustomButton
              btnType="button"
              BtnClassName="btn btn-secondary"
              BtnTxt={<>Back</>}
              ClickEvent={handleBackToLayout}
            />
            <CustomButton
              disabledButton={!isValidationPassed}
              btnType="button"
              BtnClassName={`add-layout-buttons ${
                !isValidationPassed ? "disabled-button" : ""
              }`}
              BtnTxt={<>Save Display</>}
              ClickEvent={handleSaveDisplay}
            />
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        size="sm"
        animation
        show={showPlusModal}
        onHide={handlePlusClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header>
          <div style={{ width: "100%" }}>
            <h4 style={{ fontSize: "16px" }}>Do you want to delete it ?</h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row className="">
            <Col style={{ display: "flex", justifyContent: "space-around" }}>
              <CustomButton
                BtnTxt={<>Yes</>}
                BtnClassName="yes-modal-btn"
                ClickEvent={() => {
                  handleDeleteLayout(layoutsId, displayId, deletionIndex);
                  setPlusModal(false);
                }}
              />
              <CustomButton
                BtnTxt={<>No</>}
                BtnClassName="yes-modal-btn"
                ClickEvent={() => setPlusModal(false)}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        size="sm"
        animation
        show={deactiveShowModal}
        onHide={handleDeactiveModal}
        backdrop="static"
      >
        <Modal.Header>
          <div style={{ width: "100%" }}>
            <h4 style={{ fontSize: "16px", textAlign: "center" }}>
              This is a active Display. Are you sure you want to deactivate it ?
            </h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row className="">
            <Col style={{ display: "flex", justifyContent: "space-around" }}>
              <CustomButton
                BtnTxt={<>Yes</>}
                BtnClassName="yes-modal-btn"
                ClickEvent={() => {
                  clickToDeactive();
                  setDeactiveShowModal(false);
                }}
              />
              <CustomButton
                BtnTxt={<>No</>}
                BtnClassName="yes-modal-btn"
                ClickEvent={() => setDeactiveShowModal(false)}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        size="sm"
        animation
        show={showrefreshmodal}
        onHide={handlerefreshmodal}
        backdrop="static"
      >
        <Modal.Header>
          <div style={{ width: "100%" }}>
            <h4 style={{ fontSize: "16px", textAlign: "center" }}>
              Do you want to refresh the display ?
            </h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row className="">
            <Col style={{ display: "flex", justifyContent: "space-around" }}>
              <CustomButton
                BtnTxt={<>Yes</>}
                BtnClassName="yes-modal-btn"
                ClickEvent={() => {
                  handleRefresh();
                  setShowrefreshmodal(false);
                }}
              />
              <CustomButton
                BtnTxt={<>No</>}
                BtnClassName="yes-modal-btn"
                ClickEvent={() => setShowrefreshmodal(false)}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Toaster position="bottom-right" className="tw-mr-4" />
    </div>
  );
};

const mapStateToProps = (state) => ({
  accessToken: state.accessToken,
  userId: state.userProfile.userId,
  sellerId: state.sellerIdReducer,
  currentBusiness: state.currentBusiness,
  ...state,
});

export default connect(mapStateToProps)(DisplayPreview);
